import {API} from "./API";
import {Customer} from "../models/Customer";

export class CustomersAPI extends API<Customer> {

	constructor () {
		super("customers");
    }
}
